<header class="{{ showBookmarkSubMenu ? 'bookmark' : '' }}">

  <div class="header-bottom">
    <div class="inner wrap header-inner">

      <h1 class="logo">
        <a [routerLink]="['/']"
           (click)="onClickHome($event)"
           aria-label="듣고 배우는 한국어 홈">
          <span class="visually-hidden">듣고 배우는 한국어</span>
        </a>
      </h1>

      <div class="menu-box">
        <nav class="header-top-menu">
          <div class="header-top-menu-box">
            <a class="header-top-menu-btn {{ isBookmarkPage ? 'on' : '' }}"
               (click)="onToggleBookmarkSubMenu($event)">책갈피</a>
            <app-header-bookmark-menu *ngIf="showBookmarkSubMenu"
                                      (closePopup)="onCloseBookmarkSubMenu()"></app-header-bookmark-menu>
          </div>
          <a class="header-top-menu-btn"
             (click)="ToggleLargeMode($event)" [innerHTML]="getLargeModeTxt | keepHtml"></a>
          <a class="header-top-menu-btn {{ selectedMenu === MENU_PAGE.OPTIONS ? 'on' : '' }}"
             [routerLink]="['/options']">설정</a>
          <!-- a class="header-top-menu-btn {{ selectedMenu === MENU_PAGE.REFERENCE ? 'on' : '' }}"
             [routerLink]="['/reference']">참고 자료</a -->
          <a class="header-top-menu-btn {{ selectedMenu === MENU_PAGE.BBS_NOTICE ? 'on' : '' }}"
             [routerLink]="['/admin-msg']">운영자의 말</a>
          <a class="header-top-menu-btn {{ selectedMenu === MENU_PAGE.BBS_USAGE ? 'on' : '' }}"
             [routerLink]="['/board', BBSCategory.USAGE]">베풀기</a>
          <a class="header-top-menu-btn {{ selectedMenu === MENU_PAGE.DONATION ? 'on' : '' }}"
             [routerLink]="['/options']">응원 하기</a>
        </nav>

        <nav class="header-bottom-mnu">

          <div class="nav-box {{ isWordPage ? 'on' : '' }}">
            <a class="nav-btn can-select" (click)="onClickWord($event)">
              <span class="nav-txt">단어<small>와</small> 예문</span>
            </a>
          </div>
          <div class="nav-box {{ selectedMenu === MENU_PAGE.EXAMPLE_LISTEN ? 'on' : '' }}">
            <a class="nav-btn can-select" [routerLink]="['/example', LIST_TYPE.SERVER]">
              <span class="nav-txt">문장 듣기</span>
            </a>
          </div>
          <div class="nav-box {{ isSaseungPage ? 'on' : '' }}">
            <a class="nav-btn can-select" [routerLink]="['/saseung', LIST_TYPE.SERVER]">
              <span class="nav-txt">사 성 옥편</span>
            </a>
          </div>
          <div class="nav-box {{ selectedMenu === MENU_PAGE.HOMONYM ? 'on' : '' }}">
            <a class="nav-btn can-select" (click)="onClickHomonym($event)">
              <span class="nav-txt">같은 글자<span class="size-70">,</span>&nbsp;다른 소리</span>
            </a>
          </div>
          <div class="nav-box {{ isSajaseungeoPage ? 'on' : '' }}">
            <!-- a class="nav-btn" [routerLink]="['/proper-wording']" -->
            <a class="nav-btn" (click)="onClickSajaseungeo($event)">
              <span class="nav-txt">사 자 성어</span>
            </a>
          </div>
          <div class="nav-box {{ isDialectPage ? 'on' : '' }}">
            <a class="nav-btn can-select" [routerLink]="['/dialect']">
              <span class="nav-txt">모두 우리말</span>
            </a>
          </div>
          <div class="nav-box {{ selectedMenu === MENU_PAGE.PROVERB ? 'on' : '' }}">
            <a class="nav-btn can-select" [routerLink]="['/proverb', LIST_TYPE.SERVER]">
              <span class="nav-txt">속담</span>
            </a>
          </div>
          <div class="nav-box {{ selectedMenu === MENU_PAGE.MOVIE_COLLECT ? 'on' : '' }}">
            <a class="nav-btn can-select" [routerLink]="['/movie-collect', LIST_TYPE.SERVER]">
              <span class="nav-txt">동영상 모아 보기</span>
            </a>
          </div>

      </nav>
      </div>

    </div>
  </div>

</header>
